import { observable, action, makeObservable } from 'mobx';

class UserStore {
  userName = '';

  accessToken = null;

  isLoggedIn = false;

  isRegistered = false;

  constructor() {
    makeObservable(this, {
      userName: observable,
      accessToken: observable,
      isLoggedIn: observable,
      isRegistered: observable,
      init: action,
      logout: action
    });
  }

  init() {
    const authToken = localStorage.getItem('janrainCaptureToken');
    if (authToken) {
      let expiry = localStorage.getItem('janrainCaptureToken_Expires');
      if (new Date(expiry) > new Date()) {
        if (!this.accessToken) {
          this.accessToken = authToken;
        }
        if (!this.userName) {
          this.userName =
            localStorage.getItem('janrainCaptureReturnExperienceData') &&
            JSON.parse(
              localStorage.getItem('janrainCaptureReturnExperienceData')
            ).givenName;
        }
        if (!this.isLoggedIn) {
          this.isLoggedIn = true;
        }
        this.isRegistered = true;
      }
    } else {
      this.isRegistered = false;
    }
  }

  logout = () => {
    localStorage.removeItem('janrainCaptureToken');
    localStorage.removeItem('janrainCaptureReturnExperienceData_Expires');
    localStorage.removeItem('janrainCaptureReturnExperienceData');
    this.isLoggedIn = false;
    this.isRegistered = false;
    this.accessToken = null;
    this.userName = '';
  };
}

const store = new UserStore();

export default store;
